import api from './api';
import { Organization, OrganizationStats } from '../types';

interface RegisterOrganizationData {
  organization_name: string;
  base_currency?: string;
}

interface OrganizationUpdateData {
  organization_name?: string;
  base_currency?: string;
}

interface OrganizationUser {
  user_id: number;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
}

const tenantService = {
  // Register new organization
  registerOrganization: async (orgData: RegisterOrganizationData): Promise<any> => {
    const response = await api.post('/organizations/register', orgData);
    return response.data;
  },

  // Get current organization
  getCurrentOrganization: async (): Promise<{ organization: Organization }> => {
    const response = await api.get<{ organization: Organization }>('/organizations/current');
    return response.data;
  },

  // Update organization
  updateOrganization: async (orgData: OrganizationUpdateData): Promise<{ organization: Organization }> => {
    const response = await api.put<{ organization: Organization }>('/organizations/current', orgData);
    return response.data;
  },

  // Get my organizations
  getMyOrganizations: async (): Promise<{ organizations: Organization[] }> => {
    const response = await api.get<{ organizations: Organization[] }>('/organizations/my');
    return response.data;
  },

  // Switch organization
  switchOrganization: async (organizationId: number): Promise<any> => {
    const response = await api.post(`/organizations/switch/${organizationId}`);
    localStorage.setItem('organizationId', organizationId.toString());
    return response.data;
  },

  // Get organization stats
  getOrganizationStats: async (): Promise<OrganizationStats> => {
    const response = await api.get<{ success: boolean; data: OrganizationStats }>('/organizations/current/stats');
    return response.data.data;
  },

  // Get organization users
  getOrganizationUsers: async (): Promise<{ users: OrganizationUser[] }> => {
    const response = await api.get<{ users: OrganizationUser[] }>('/organizations/current/users');
    return response.data;
  },

  // Invite user to organization
  inviteUser: async (email: string, role: string): Promise<any> => {
    const response = await api.post('/organizations/current/users/invite', {
      email,
      role,
    });
    return response.data;
  },

  // Update user role
  updateUserRole: async (userId: number, role: string): Promise<any> => {
    const response = await api.put(`/organizations/current/users/${userId}/role`, {
      role,
    });
    return response.data;
  },

  // Remove user from organization
  removeUser: async (userId: number): Promise<any> => {
    const response = await api.delete(`/organizations/current/users/${userId}`);
    return response.data;
  },

  // Get current organization ID from storage
  getCurrentOrganizationId: (): string | null => {
    return localStorage.getItem('organizationId');
  },

  // Set current organization ID
  setCurrentOrganizationId: (organizationId: number): void => {
    localStorage.setItem('organizationId', organizationId.toString());
  },
};

export default tenantService;
